import { TranslateModule } from '@ngx-translate/core';
import { SlicePipe } from '@angular/common';
import { Subscription } from 'rxjs';

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef, Component, EventEmitter, HostBinding, Input, OnDestroy, OnInit, Output, ViewEncapsulation
} from '@angular/core';

import {
  DeviceService, IconSizeEnum, ILink, ImageRatioEnum, SdBannerComponent, SdHtmlComponent, SdIconComponent, SdLinkComponent,
  SdListComponent, SdSkeletonComponent, SdThemeComponent, SkeletonAppearanceEnum, ThemesTextEnum
} from '@seb/web-design-system/core';

import { SdRatingComponent } from '@seb/web-design-system/reviews';

import type { ISubcategory } from './subcategory.interface';

@Component({
  selector: 'sd-subcategory',
  templateUrl: './subcategory.component.html',
  styleUrls: ['./subcategory.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdBannerComponent,
    SdLinkComponent,
    SdListComponent,
    SdRatingComponent,
    SdIconComponent,
    SdSkeletonComponent,
    SdHtmlComponent,
    SlicePipe,
    TranslateModule
  ]
})
export class SdSubcategoryComponent extends SdThemeComponent implements OnInit, OnDestroy {
  @Input()
  isLoading = false;

  @Input()
  data: ISubcategory;

  @Input()
  isLarge = false;

  @Input()
  contentThemesConfig: ThemesTextEnum = ThemesTextEnum.dark;

  @Output()
  subCatClicked = new EventEmitter<ILink>();

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.isLarge ? 'is-large' : '',
      this.contentThemesConfig ? 'is-theme-' + this.contentThemesConfig : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  skeletonAppearanceEnum = SkeletonAppearanceEnum;
  subscriptions = new Subscription();
  iconSize = IconSizeEnum;
  isMobile$: boolean;
  isDevice$: boolean;
  imageRatio = ImageRatioEnum;
  themesTextEnum = ThemesTextEnum;

  constructor(
    private cdRef: ChangeDetectorRef,
    private deviceService: DeviceService
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.deviceService.isMobile.subscribe((x) => {
        this.isMobile$ = x;
        this.cdRef.markForCheck();
      })
    );

    this.subscriptions.add(
      this.deviceService.isDevice.subscribe((x) => {
        this.isDevice$ = x;
        this.cdRef.markForCheck();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onSubCatLinkClick(element: ILink): void {
    this.subCatClicked.emit(element);
  }
}
